import { createClient } from "@sanity/client"

export const client = createClient({
    projectId: "pqaypdba",
    dataset: "production",
    useCdn: true,
    apiVersion: "2024-01-01"
})

export const termsClient = createClient({
    projectId: "nhhf4blo",
    dataset: "production",
    useCdn: true,
    apiVersion: "2024-01-01"
})